import React, { useState } from "react";
import styles from "./OrderForm.module.scss";
import CustomInputIconComponent from "../../../../shared/custom-input-icon-component/CustomInputIconComponent";
import currencyIcon from "../../../../../assets/images/order/CurrencyIcon.svg";
import plusIcon from "../../../../../assets/images/order/AddProductIcon.svg";
import MainButton from "../../../../shared/button/MainButton";

export default function OrderForm() {
  const [products, setProducts] = useState([
    {
      id: Math.random().toString(36).substring(2, 12),
      values: {
        productLink: "",
        productPrice: "",
        productServicePercent: "",
        productAmount: "",
        color: "",
        size: "",
        productDetails: "",
      },
    },
  ]);

  const handleValueChange = (val: string, label: string, id: string) => {
    setProducts((prevProducts) =>
      prevProducts.map((product) =>
        product.id === id
          ? { ...product, values: { ...product.values, [label]: val } }
          : product
      )
    );
  };

  const addNewProduct = () => {
    setProducts((prevProducts) => [
      ...prevProducts,
      {
        id: Math.random().toString(36).substring(2, 12),
        values: {
          productLink: "",
          productPrice: "",
          productServicePercent: "",
          productAmount: "",
          color: "",
          size: "",
          productDetails: "",
        },
      },
    ]);
  };

  return (
    <div>
      <p className={styles.orders_title}>Sİfarİş et</p>

      <div className={styles.order_form}>
        {products.map((product, index) => (
          <div className={styles.order_form_items} key={product.id}>
            <div className={styles.order_form_three_items}>
              <CustomInputIconComponent
                name={`productLink${index === 0 ? "" : `[${index}]`}`}
                placeholder="Məhsulun linkini daxil et"
                label="Məhsulun linki"
                type="text"
                value={product.values.productLink}
                onChange={(val) =>
                  handleValueChange(val, "productLink", product.id)
                }
              />
              <CustomInputIconComponent
                name={`productPrice${index === 0 ? "" : `[${index}]`}`}
                placeholder="0.00 TL"
                label="Məhsulun qiymət"
                type="text"
                value={product.values.productPrice}
                onChange={(val) =>
                  handleValueChange(val, "productPrice", product.id)
                }
                rightIcon={currencyIcon}
              />
              <CustomInputIconComponent
                name={`productServicePercent${index === 0 ? "" : `[${index}]`}`}
                placeholder="0.00TL"
                label="Məhsulun xidmət faizi (+3)"
                type="text"
                value={product.values.productServicePercent}
                onChange={(val) =>
                  handleValueChange(val, "productServicePercent", product.id)
                }
              />
            </div>

            <div className={styles.order_form_three_items}>
              <CustomInputIconComponent
                name={`productAmount${index === 0 ? "" : `[${index}]`}`}
                placeholder="0"
                label="Məhsulun sayı"
                type="text"
                value={product.values.productAmount}
                onChange={(val) =>
                  handleValueChange(val, "productAmount", product.id)
                }
              />

              <CustomInputIconComponent
                name={`color${index === 0 ? "" : `[${index}]`}`}
                placeholder="Rəngi qeyd et"
                label="Rəng"
                type="text"
                value={product.values.color}
                onChange={(val) => handleValueChange(val, "color", product.id)}
              />

              <CustomInputIconComponent
                name={`size${index === 0 ? "" : `[${index}]`}`}
                placeholder="0"
                label="Ölçü"
                type="text"
                value={product.values.size}
                onChange={(val) => handleValueChange(val, "size", product.id)}
              />
            </div>

            <CustomInputIconComponent
              name={`productDetails${index === 0 ? "" : `[${index}]`}`}
              placeholder="Məhsulun detalları..."
              label="Məhsulun detalları"
              type="textarea"
              value={product.values.productDetails}
              onChange={(val) =>
                handleValueChange(val, "productDetails", product.id)
              }
            />
          </div>
        ))}
      </div>

      <div className={styles.order_footer}>
        <button className={styles.add_product_btn} onClick={addNewProduct}>
          <img src={plusIcon} alt="plus" />
          <p className={styles.add_product_text}>Yeni məhsul əlavə et</p>
        </button>

        <div className={styles.complate_order}>
          <div className={styles.total_price_container}>
            <p className={styles.total_price_title}>Yekun Məbləğ</p>
            <p className={styles.total_price_text}>0.00 TL</p>
          </div>

          <MainButton text="Təsdiqlə" />
        </div>
      </div>
    </div>
  );
}
